import { ReactComponent as SlidesOutline } from 'assets/icons/icon-slides-outline.svg';

export default SlidesOutline;
